import { min } from 'lib/arrayUtils'
import { useMemo } from 'react'
import useStableObjectReference from './useStableObjectReference'

interface Options {
  durationThreshold?: number
}

export default function useMinimumDurationPackageWithBonusInclusions(offer: App.Offer | App.OfferSummary, options?: Options) {
  // Allows devs to pass inline without producing unnecessary rerenders
  const stableOptions = useStableObjectReference(options)

  return useMemo(() => {
    const packagesWithBonusInclusions = offer.packages.filter(p => {
      const meetsDurationConditions = stableOptions?.durationThreshold ? p.duration >= stableOptions.durationThreshold : true

      return (!!p.bonusInclusions && p.bonusInclusions.length > 0) && meetsDurationConditions
    })

    return min(packagesWithBonusInclusions, (p) => p.duration)
  }, [offer, stableOptions])
}
